import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import MainTechPage from './pages/MainTechPage';
import IadgPage from './pages/IadgPage';
import ServicosPage from './pages/ServicosPage';
import SobrePage from './pages/SobrePage';
import ContatoPage from './pages/ContatoPage';
import ServicoInspecaoPage from './pages/ServicoInspecaoPage';
import ServicoIntegridadePage from './pages/ServicoIntegridadePage';
import ServicoEnsaiosPage from './pages/ServicoEnsaiosPage';
import ServicoNormativasPage from './pages/ServicoNormativasPage';
import ServicoCalculoPage from './pages/ServicoCalculoPage';
import ServicoManutencaoPage from './pages/ServicoManutencaoPage';
import ServicoEngenhariaPage from './pages/ServicoEngenhariaPage';
import CasesPage from './pages/CasesPage';
import CertificacoesPage from './pages/CertificacoesPage';
import BlogPage from './pages/BlogPage';
import FAQPage from './pages/FAQPage';
import NormativasPage from './pages/NormativasPage';
import NR13Page from './pages/NR13Page';
import NR11Page from './pages/NR11Page';
import NR20Page from './pages/NR20Page';
import NR33Page from './pages/NR33Page';
import NR35Page from './pages/NR35Page';
import ClienteAreaPage from './pages/ClienteAreaPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path="maintech" element={<MainTechPage />} />
          <Route path="iadg" element={<IadgPage />} />
          <Route path="servicos" element={<ServicosPage />} />
          <Route path="servicos/inspecao" element={<ServicoInspecaoPage />} />
          <Route path="servicos/integridade" element={<ServicoIntegridadePage />} />
          <Route path="servicos/ensaios" element={<ServicoEnsaiosPage />} />
          <Route path="servicos/normativas" element={<ServicoNormativasPage />} />
          <Route path="servicos/calculo" element={<ServicoCalculoPage />} />
          <Route path="servicos/manutencao" element={<ServicoManutencaoPage />} />
          <Route path="servicos/engenharia" element={<ServicoEngenhariaPage />} />
          <Route path="sobre" element={<SobrePage />} />
          <Route path="contato" element={<ContatoPage />} />
          <Route path="cases" element={<CasesPage />} />
          <Route path="certificacoes" element={<CertificacoesPage />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="faq" element={<FAQPage />} />
          <Route path="normativas" element={<NormativasPage />} />
          <Route path="normativas/nr13" element={<NR13Page />} />
          <Route path="normativas/nr11" element={<NR11Page />} />
          <Route path="normativas/nr20" element={<NR20Page />} />
          <Route path="normativas/nr33" element={<NR33Page />} />
          <Route path="normativas/nr35" element={<NR35Page />} />
          <Route path="cliente-area" element={<ClienteAreaPage />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
